<template>
  <article>
    <tab-list
      :tab-list="tabList"
      :status.sync="tabStatus"
      @tab-change="onShiftTab">
    </tab-list>
    <second-sel
      store-name="续保业务"
      :flag.sync="flagA"
      :selList="tabObj[tabStatus]"
      @select-tab="selectTab">
    </second-sel>
    <data-summary
      :title-list="summaryTitle"
      :data-list="summaryData">
    </data-summary>
    <!-- 集团信息 -->
    <data-table
      table-title="各门店统计"
      :title-list="storeTableTitle"
      :data-list="storeTableData"
      :is-link="true"
      url="/manageAnalysis/insurance">
    </data-table>
  </article>
</template>
<script>
import util from '../../common/util'
import TabList from '../components/TabList'
import SecondSel from './components/SecondSel'
import DataSummary from './components/DataSummary'
import DataTable from './components/DataTable'
const day = new Date()
const today = util.formatTime(day, 'yyyy-MM-dd')
const yesterday = util.formatTime(day.valueOf() - 24 * 3600 * 1000, 'yyyy-MM-dd')
const thisMonth = util.formatTime(day, 'yyyy-MM')
const lastMonth = util.getLastMonth(thisMonth)
export default {
  components: {
    TabList,
    SecondSel,
    DataSummary,
    DataTable
  },
  data() {
    return {
      tabStatus: 'monthly',
      flagA: thisMonth, // 默认日期是本月
      tabList: [
        { key: 'daily', name: '日' },
        { key: 'monthly', name: '月' }
      ],
      tabObj: {
        daily: [
          { key: today, name: '今日' },
          { key: yesterday, name: '昨日' }
        ],
        monthly: [
          { key: thisMonth, name: '本月' },
          { key: lastMonth, name: '上个月' }
        ]
      },
      // 数据概览
      summaryTitle: [],
      summaryData: {},
      dailySummary: [
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' },
        { key: 'ins_premiums_avg', name: '保单均价' },
        { key: 'ins_quotes_count', name: '报价数（次）' }
      ],
      monthlySummary: [
        { key: 'ins_expires_count', name: '到期客户' },
        { key: 'ins_completed', name: '续回客户' },
        { key: 'ins_completed_rate', name: '续回率' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' },
        { key: 'ins_premiums_avg', name: '保单均价' },
        { key: 'ins_quoted', name: '已报价(人)' },
        { key: 'ins_cars_count', name: '保有车辆总数' }
      ],
      // 门店统计
      storeTableTitle: [],
      storeTableData: [],
      dailyStoreTableTitle: [ // 日维度各门店
        { key: 'name', name: '门店' },
        { key: 'ins_quotes_count', name: '报价数（次）' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' }
      ],
      monthlyStoreTableTitle: [ // 月维度各门店
        { key: 'name', name: '门店' },
        { key: 'ins_cars_count', name: '保有车辆' },
        { key: 'ins_expires_count', name: '到期客户' },
        { key: 'ins_quoted', name: '已报价（人）' },
        { key: 'ins_completed', name: '续回客户' },
        { key: 'ins_completed_rate', name: '续回率%' },
        { key: 'ins_orders_count', name: '保单合计' },
        { key: 'ins_premiums_total', name: '保费合计' },
        { key: 'ins_premiums_avg', name: '保单均价' }
      ]
    }
  },
  mounted() {
    // 默认获取月数据
    this.selectData(this.flagA)
  },
  methods: {
    onShiftTab() {
      this.flagA = this.tabObj[this.tabStatus][0].key
      this.selectData(this.flagA)
    },
    selectTab() {
      this.selectData(this.flagA)
    },
    selectData(day) {
      let queryDay = this.tabStatus === 'daily' ? day : `${day}-01`
      let params = {
        date: queryDay
      }
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.dataAnalysis.getInsuranceData(params, this.tabStatus).then(res => {
        if (res.code === 0) {
          let countData = res.data[this.flagA]
          // 数据概览
          this.summaryTitle = this[`${this.tabStatus}Summary`]
          this.summaryData = this.getSummary(countData.total)
          // 门店统计表数据
          this.storeTableTitle = this[`${this.tabStatus}StoreTableTitle`]
          this.storeTableData = this.getFormateData(countData.stores_detail)
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    formatePrice(number) {
      number = number || 0
      return (number / 100).toFixed(2)
    },
    formateRate(number) {
      number = number || 0
      return (number * 100).toFixed(2) + '%'
    },
    getFormateData(arr) {
      arr.forEach(v => {
        if (v.ins_premiums_total) v.ins_premiums_total = this.formatePrice(v.ins_premiums_total)
        if (v.ins_premiums_avg) v.ins_premiums_avg = this.formatePrice(v.ins_premiums_avg)
        if (v.ins_completed_rate) v.ins_completed_rate = this.formateRate(v.ins_completed_rate)
      })
      return arr
    },
    getSummary(summary) { // 指标数据展览
      // 收车均价可能为null,需要转换单位
      summary.ins_premiums_total = this.formatePrice(summary.ins_premiums_total)
      summary.ins_premiums_avg = this.formatePrice(summary.ins_premiums_avg)
      if (summary.ins_completed_rate) summary.ins_completed_rate = this.formateRate(summary.ins_completed_rate)
      return summary
    }
  }
}

</script>
<style lang="less">
</style>
